module.exports = __webpack_public_path__ + "img/br51.6acacee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br51.jpg
// module id = hhP6
// module chunks = 0